import { FilterOutlined } from "@ant-design/icons";
import { Button, Popover } from "antd";
import { ReactNode, useState } from "react";
import { isMobile } from "react-device-detect";

interface PropsExportBtn {
    filters: ReactNode;
    title?: string;
    style?: Object;
}

export default function FilterButton({
    filters,
    title = 'Filtrar dados',
    style
}: PropsExportBtn) {
    const [openFilters, setOpenFilters] = useState<boolean>(false);
    const handleOpenFiltersChange = (open: boolean) => {
        setOpenFilters(open);
    };

    return (
        <Popover
            content={<div style={{ paddingLeft: 10, paddingRight: 10 }}>
                {filters}
            </div>}
            title={title}
            trigger="click"
            placement="bottom"
            open={openFilters}
            onOpenChange={handleOpenFiltersChange}
        >
            <Button
                type="link"
                className="show_result_size"
                style={{ paddingRight: 24, ...style }}
                block={isMobile}>
                <FilterOutlined /> {title}</Button>
        </Popover>
    )
}